import React, { useEffect, useState } from "react";

import { Field, useField } from "formik";

import { Grid, Tooltip } from "@material-ui/core";

import { capitalizeText } from "@ip-utils";

export default function Base({
  as,
  helperText,
  label,
  name,
  tooltip,
  tooltipDisabled,
  warn,
  xs = 12,
  sm,
  md,
  lg,
  ...props
}) {
  const [, meta] = useField(name);
  const [error, setError] = useState(false);
  const [extraProps, setExtraProps] = useState({});
  const [helperTextContent, setHelperTextContent] = useState(null);
  const [hover, setHover] = useState(false);
  const [labelContent, setLabelContent] = useState(null);

  useEffect(() => {
    const labelContent = label || capitalizeText(name.replace(/.*\./, ""));
    setLabelContent(labelContent);

    if (tooltip) {
      extraProps.onBlur = () => setHover(false);
      extraProps.onFocus = () => setHover(true);
      extraProps.onMouseOut = () => setHover(false);
      extraProps.onMouseOver = () => setHover(true);
      setExtraProps(extraProps);
    }
  }, [extraProps, label, name, tooltip]);

  useEffect(() => {
    setError(!!meta.error || warn);

    const helperTextContent =
      (helperText || meta.error) &&
      [helperText].concat(meta.error).map(
        (line, key) =>
          line && (
            <React.Fragment key={key}>
              {line}
              <br />
            </React.Fragment>
          )
      );
    setHelperTextContent(helperTextContent);
  }, [meta.error, helperText, name, warn]);

  const element = (
    <Grid item sm={sm} md={md} lg={lg} xs={xs}>
      <Field
        as={as}
        error={error}
        helperText={helperTextContent}
        label={labelContent}
        name={name}
        variant="outlined"
        {...extraProps}
        {...props}
      />
    </Grid>
  );

  return tooltip ? (
    <Tooltip open={!tooltipDisabled && hover} title={tooltip}>
      {element}
    </Tooltip>
  ) : (
    element
  );
}
